import { ActionCableService } from '@action-cable'
import { inject, Injectable } from '@angular/core'
import type { Observable } from 'rxjs'
import { filter, map, switchMap } from 'rxjs'

import { AuthStore } from '@app/modules/auth/store/auth.store'

import type { Notification } from '../models/notification'

@Injectable({ providedIn: 'root' })
export class NotificationsChannelService {
  private readonly actionCableService = inject(ActionCableService)
  private readonly authStore = inject(AuthStore)

  readonly channel$ = this.authStore.authenticationSuccess$.pipe(
    switchMap(() => this.actionCableService.getChannel('NotificationsChannel')),
  )

  notifications(): Observable<Notification> {
    return this.channel$.pipe(
      switchMap(channel => channel.messages$),
      filter(data => !!data.notification),
      map(({ notification }) => JSON.parse(notification)),
    )
  }
}
